import { FilterOutlined, PlusCircleOutlined } from "@ant-design/icons";
import { ConfigProvider, Dropdown, Menu, Table } from "antd";
import moment from "moment";
import React, { useEffect, useState } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { useSelector } from "react-redux";
import { ClipLoader, ScaleLoader } from "react-spinners";
import SearchInput from "../SearchInput";
import "./table.css";

const TableWrap = ({
  columns,
  data,
  pagination,
  scroll,
  rowSelection,
  className,
  addNewBtn,
  btnsComponent,
  btnsOnly,
  handleSearch,
  selectedRows,
  approveClick,
  approveLoading,
  renderEmpty,
  rejectClick,
  expandable,
  hasExport,
  onExport,
  filterMenu,
  sort,
  dateFilter,
  exportLoading,
  loading,
  hasBack,
  handleBack,
  ...props
}) => {
  const [activeIndex, setActiveIndex] = useState(0);
  const [activeButton, setActiveButton] = useState("");
  const [activeFilter, setActiveFilter] = useState("");

  useEffect(() => {
    if (props.activeIndex) {
      setActiveButton("Active");
      setActiveFilter("A");
    }
    // eslint-disable-next-line
  }, [props.activeIndex]);

  useEffect(() => {
    if (props.activeButton) {
      let obj = props.topFilters?.find(
        (ele) => ele.filter === props.activeButton
      );
      if (obj?.label) {
        setActiveButton(obj.label);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.activeButton]);

  React.useEffect(() => {
    setDropMenu(
      <Menu>
        {props?.topFilters?.map((ele, i) =>
          (activeIndex === 0 ? i !== 0 : i !== activeIndex) ? (
            <Menu.Item key={i}>
              <button
                className="tableFilter"
                onClick={() => {
                  props.handleFilter && props.handleFilter(ele.filter);
                  setActiveIndex(i);
                  setActiveButton(ele.label);
                  setActiveFilter(ele.filter);
                }}
              >
                <span>{ele.label}</span>
              </button>
            </Menu.Item>
          ) : null
        )}
      </Menu>
    );

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeIndex]);
  const handleMenuClick = () => {};

  const [dropMenu, setDropMenu] = useState(
    <Menu>
      {props?.topFilters?.map((ele, i) =>
        i !== 0 ? (
          <Menu.Item key={i}>
            <button
              className="tableFilter"
              onClick={() => {
                props.handleFilter && props.handleFilter(ele.filter);
                setActiveIndex(i);
                setActiveButton(ele.label);
                setActiveFilter(ele.filter);
                handleMenuClick();
              }}
            >
              <span>{ele.label}</span>
            </button>
          </Menu.Item>
        ) : null
      )}
    </Menu>
  );

  const is_admin = useSelector(
    (state) => state?.auth?.localVariables?.is_admin
  );

  useEffect(() => {
    setDropMenu(
      <Menu>
        {props?.topFilters?.map((ele, i) =>
          !ele.isActive ? (
            <Menu.Item key={i}>
              <button
                className="tableFilter"
                onClick={() => {
                  props.handleFilter && props.handleFilter(ele.filter);
                  setActiveIndex(i);
                  setActiveButton(ele.label);
                  setActiveFilter(ele.filter);
                  handleMenuClick();
                }}
              >
                <span>{ele.label}</span>
              </button>
            </Menu.Item>
          ) : null
        )}
      </Menu>
    );
    // eslint-disable-next-line
  }, [is_admin, props.activeButton]);

  let sort_key = {
    from_date: "Start date",
    to_date: "End date",
  };

  const dateDropMenu = () => {
    return <DateFilter />;
  };
  return (
    <>
      <div className="paycraft-table container-table">
        {btnsOnly && (
          <div className="top-filter">
            <div className="flt-btns">
              {props.isTopTxFilter ? (
                <>
                  {props?.topFilters?.map((ele, i) =>
                    ele.isActive || (ele.isActive === undefined && i === 0) ? (
                      <button
                        key={i}
                        className="active"
                        onClick={() => {
                          props.handleFilter &&
                            props.handleFilter(activeFilter || ele.filter);
                          setActiveIndex(i);
                        }}
                      >
                        <span>{activeButton || ele.label}</span>
                      </button>
                    ) : null
                  )}
                  {!props.filter && (
                    <Dropdown overlay={dropMenu}>
                      <button
                        onClick={() => {
                          // setActiveIndex(100);
                        }}
                      >
                        <FilterOutlined />
                      </button>
                    </Dropdown>
                  )}
                </>
              ) : null}
            </div>
            <div className="d-flex">{btnsComponent}</div>
          </div>
        )}
        {props.isTopFilter && (
          <div className="top-filter">
            {!filterMenu ? (
              <div className="flt-btns">
                {props?.topFilters?.map((ele, i) =>
                  ele.isActive || (ele.isActive === undefined && i === 0) ? (
                    <button
                      key={i}
                      className="active"
                      onClick={() => {
                        props.handleFilter &&
                          props.handleFilter(activeFilter || ele.filter);
                        setActiveIndex(i);
                      }}
                    >
                      <span>{activeButton || ele.label}</span>
                    </button>
                  ) : null
                )}
                {!props.filter && (
                  <Dropdown overlay={dropMenu}>
                    <button
                      onClick={() => {
                        // setActiveIndex(100);
                      }}
                    >
                      <FilterOutlined />
                    </button>
                  </Dropdown>
                )}
                {!props?.isActionAfterSearch && btnsComponent}
              </div>
            ) : dateFilter ? null : (
              <div></div>
            )}
            {dateFilter && (
              <div className="top-filter">
                <div className="flt-btns">
                  <Dropdown overlay={dateDropMenu}>
                    <button
                      onClick={() => {
                        // setActiveIndex(100);
                      }}
                    >
                      <FilterOutlined />
                    </button>
                  </Dropdown>
                </div>
              </div>
            )}
            <div className="d-flex">
              {selectedRows?.length > 0 && (
                <div className="action-btns">
                  <button
                    className="approve"
                    disabled={approveLoading}
                    onClick={approveClick}
                  >
                    Approve
                  </button>
                  <button
                    className="reject"
                    disabled={approveLoading}
                    onClick={rejectClick}
                  >
                    Reject
                  </button>
                </div>
              )}
              {addNewBtn && addNewBtn()}
              {!props.isSearch && (
                <SearchInput
                  placeholder={props.placeholder}
                  handleSearch={(val) => {
                    handleSearch && handleSearch(val);
                  }}
                />
              )}
              {props?.isActionAfterSearch && btnsComponent}
              {/* {hasExport && (
                <div className="mr1">
                  <Select
                    placeholder="Export as"
                    options={[
                      {
                        label: "PDF",
                        value: "PDF",
                      },
                      {
                        label: "CSV",
                        value: "CSV",
                      },
                    ]}
                    onChange={(value) => {
                      onExport(value);
                    }}
                    disabled={exportLoading}
                  />
                </div>
              )} */}
              {hasExport && (
                <div className="mr1 has-export-section">
                  <Dropdown
                    overlay={
                      exportLoading ? (
                        <div style={{ padding: "10px", textAlign: "center" }}>
                          <ClipLoader size={15} color="blue" />
                        </div>
                      ) : (
                        <Menu
                          onClick={({ key }) => onExport(key)}
                          items={[
                            {
                              key: "PDF",
                              label: "PDF",
                            },
                            {
                              key: "CSV",
                              label: "CSV",
                            },
                          ]}
                        />
                      )
                    }
                    disabled={exportLoading}
                  >
                    <button
                      className="ant-dropdown-link"
                      disabled={exportLoading}
                    >
                      {exportLoading ? "Loading..." : "Export as"}
                    </button>
                  </Dropdown>
                </div>
              )}
              {props.exportToExcel && (
                <div className="mr1 has-export-section">
                  <button
                    className="ant-dropdown-link"
                    disabled={exportLoading}
                    onClick={props.exportToExcel}
                  >
                    {exportLoading ? "Loading..." : "Export"}
                  </button>
                </div>
              )}
              {hasBack && (
                <div className="mr1 has-export-section">
                  <button className="primary-btn" onClick={handleBack}>
                    Back
                  </button>
                </div>
              )}
              {(props.is_admin === false || props.is_admin === "false") && (
                <div className="flt-btns">
                  <button
                    className="active"
                    onClick={(event) =>
                      props.handleAddButton && props.handleAddButton(event)
                    }
                  >
                    <span>
                      <PlusCircleOutlined />
                      {props.module === "Report"
                        ? " New Report"
                        : props.module === "Expense"
                        ? " New Expenses"
                        : ` Record ${props.module}`}
                    </span>
                  </button>
                </div>
              )}
              {!props.isMore && (
                <Dropdown
                  overlay={
                    <Menu>
                      <label className="dim-text ml1">Sort By</label>
                      {props?.dotMenu?.map((ele, i) => (
                        <Menu.Item key={i}>
                          <button
                            className="tableFilter"
                            onClick={() => {
                              props.handleSort && props.handleSort(ele);
                            }}
                          >
                            <span style={{ textTransform: "capitalize" }}>
                              {sort_key[ele]
                                ? sort_key[ele]
                                : ele?.replace("_", " ")}
                            </span>
                          </button>
                        </Menu.Item>
                      ))}
                    </Menu>
                  }
                >
                  <button className="more" style={{ fontWeight: 600 }}>
                    Sort
                  </button>
                </Dropdown>
              )}
            </div>
          </div>
        )}

        <ConfigProvider renderEmpty={renderEmpty}>
          <Table
            rowKey="id"
            columns={columns}
            dataSource={data}
            onRow={(record) => {
              return {
                onClick: (event) =>
                  props.handleRowClick && props.handleRowClick(event, record),
              };
            }}
            loading={
              loading
                ? {
                    indicator: (
                      <div className="table-loader">
                        {" "}
                        <ScaleLoader color="#262626" />{" "}
                      </div>
                    ),
                  }
                : false
            }
            pagination={pagination}
            scroll={scroll}
            rowSelection={rowSelection}
            className={className}
            expandable={expandable}
          />
        </ConfigProvider>
      </div>
    </>
  );
};

const DateFilter = () => {
  const [startDate, setStartDate] = useState(
    new Date(moment().subtract("weeks", 2).format("YYYY-MM-DD"))
  );
  const [endDate, setEndDate] = useState(
    new Date(moment().format("YYYY-MM-DD"))
  );
  return (
    <>
      <div
        className="bank-menu"
        style={{ padding: "20px", backgroundColor: "#fff" }}
      >
        <>
          <DatePicker
            selected={startDate}
            onChange={(date) => setStartDate(date)}
            selectsStart
            startDate={startDate}
            endDate={endDate}
            inline
          />
          <DatePicker
            selected={endDate}
            onChange={(date) => setEndDate(date)}
            selectsEnd
            startDate={startDate}
            endDate={endDate}
            minDate={startDate}
            inline
          />
        </>
        <div
          style={{
            display: "flex",
            gap: "!rem",
          }}
        >
          <div className="d-flex gap1">
            <button className="secondary-btn">Cancel</button>
            <button className="primary-btn">Apply</button>
          </div>
        </div>
      </div>
    </>
  );
};

export default TableWrap;
